import { get } from '../api';

const route = '/candidates';

const getCandidates = ({ candidateId = '', config, scope = '' }) =>
  scope ? get(`${route}/${candidateId}?${scope}`, config) : get(`${route}/${candidateId}`, config);

export default getCandidates;
